<template>
  <div>
    <div class="flex title" style="justify-content: space-between;">
      <Title title="查看素材"/>
      <div class="flex but" style="justify-content: space-between;">
        <!-- <button class="back" @click="$router.back()">返回</button> -->
        <button style="margin-right: 1rem;" class="copy" @click="copyTitle">复制标题</button>
        <button class="copy" @click="copy">复制内容</button>

      </div>
    </div>
    <div class="Man_content">
      <div class="Man_content_title_box">
        <h4 class="title">{{ DetailsContent.title }}</h4>
        <p class="hint">提示：本平台所发布信息的内容和准确性由提供消息的原单位或组织独立承担完全责任!</p>
      </div>
      <p class="Man_content_title flex" v-show="keywordList.length !== 0">敏感词: <i
          v-for="(item, index) in keywordList" :key="index">{{
          index == keywordList.length - 1 ? item : `${item},`
        }}</i>
      </p>
      <div style="margin-top: 20px">
        <div class="infomation">
          <div class="infomationItem">平台名称：{{ DetailsContent.guangao_title }}</div>
          <div class="line"></div>
          <div class="infomationItem" v-if="DetailsContent.category_id !==4">广告位置：{{ DetailsContent.address }}</div>
          <div class="infomationItem" v-if="DetailsContent.category_id ===4">广告时段：{{
              DetailsContent.span_time
            }}
          </div>
        </div>
        <div v-show="DetailsContent.content" class="content" v-html="DetailsContent.content"></div>
      </div>

      <specialText text="注意事项"/>
      <div style="width: 100%;display: flex;align-items: center;justify-content: space-between">
        <p class="out_text">是否设计: <span>{{ DetailsContent.design_price !== '0.00' ? '是' : '否' }}</span></p>
        <p class="out_text">投放时间: <span>{{ DetailsContent.o_time }}</span></p>
        <p class="out_text flex" v-if="DetailsContent.file">素材下载: <a :href="DetailsContent.file"
                                                                         target="_blank">下载素材</a></p>
      </div>
    </div>

    <div class="relevantQualifications_box">
      <el-divider content-position="left">相关资质</el-divider>
      <div class="relevantQualifications_content">
        <div class="Man_content_item" v-if="DetailsContent.business_license !==''">
          <div class="Man_content_item_title">
            营业执照：
          </div>
          <div class="demo-image__preview">
            <el-image
                style="width: 150px; height: 115px"
                :src="DetailsContent.business_license"
                :preview-src-list="[DetailsContent.business_license]">
            </el-image>
          </div>

          <!--          <img :src="DetailsContent.business_license">-->
        </div>
        <div class="Man_content_item" v-if="DetailsContent.shangbiao_zhengshu !==''">
          <div class="Man_content_item_title">
            商标证书：
          </div>
          <el-image
              style="width: 150px; height: 115px"
              :src="DetailsContent.shangbiao_zhengshu"
              :preview-src-list="[DetailsContent.shangbiao_zhengshu]">
          </el-image>
        </div>
        <div class="line"
             v-if="DetailsContent.business_license !=='' && DetailsContent.shangbiao_zhengshu !=='' && DetailsContent.qita_zizhi !==''"></div>
        <div class="Man_content_item" v-if="DetailsContent.qita_zizhi !==''">
          <div class="Man_content_item_title">
            其他资质：
          </div>
          <div>
            <el-image
                v-for="(item,index) in qita_zizhi_list"
                style="width: 150px; height: 115px;margin-right: 20px"
                :src="item.url"
                :preview-src-list="[item.url]">
            </el-image>
            <!--            <img :src="item.url" style="margin-right: 20px" v-for="(item,index) in qita_zizhi_list">-->
          </div>

        </div>
        <div
            v-if="DetailsContent.business_license ==='' && DetailsContent.shangbiao_zhengshu ==='' && DetailsContent.qita_zizhi ===''">
          <el-empty description="暂无" image-size="80" style="padding: 0;margin-left: 200px"></el-empty>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Title from '@/components/UserInfoTitle'
import specialText from '@/components/specialText'

export default {
  created() {
    this.get_list()
  },
  components: {
    Title,
    specialText,
  },
  data() {
    return {
      DetailsContent: {},
      // verifyArray: [],
      keywordList: [],
      qita_zizhi_list: [],
    }
  },
  // 找出敏感字-标红
  // filters: {
  //     formatTitle(value, keyword) {
  //         if (!value) return '';
  //         // value = value.length > 30 ? value.substr(0, 29) + '...' : value; //标题超过30字符展示...
  //         if (Array.isArray(keyword)) {
  //             keyword.forEach((item) => {
  //                 if (item && value.includes(item)) {
  //                     var regex = RegExp('(' + item.replace('\\$1') + ')', 'ig');
  //                     var html = '<span style="color:red">' + item + '</span>';
  //                     value = value.replace(regex, html)
  //                     console.log(value);
  //                 }
  //             })
  //         }
  //         return value;
  //     },
  // },
  methods: {
    // 复制标题
    copyTitle() {
      this.$copyText(this.DetailsContent.title).then(
          (e) => {
            return this.$message({
              message: '复制标题成功',
              type: 'success',
            })
          },
          (err) => {
            return this.$message({
              message: '复制失败',
              type: 'warning',
            })
          }
      )
    },
    copy() {
      const text = document.querySelector(".content");
      let range = document.createRange();
      range.selectNodeContents(text);
      let selection = document.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("Copy");
      // this.$toast("复制成功");
      return this.$message({
        message: '复制内容成功',
        type: 'success',
      })
    },
    get_list() {
      this.curlGet('/api/users/guanggao_order/detail', {
        id: this.$route.query.id
      }).then(res => {
        if (res.data.code) {
          this.DetailsContent = res.data.data[0]
          console.log(this.DetailsContent)
          if (this.DetailsContent.qita_zizhi !== '') {
            const paths = this.DetailsContent.qita_zizhi.split('\n');
            this.qita_zizhi_list = paths.map(path => ({name: '', url: path}));
          } else {
            this.qita_zizhi_list = []
          }
          // if (this.DetailsContent.limit_time > 0) {
          //     this.DetailsContent.limit_time = timeCut(this.DetailsContent.limit_time)
          // }
          // this.content = toText(this.DetailsContent.content)
          this.verifyTest()
        }
      })
    },
    verifyTest() {
      if (this.DetailsContent.content) {
        this.curlGet('/api/index/website').then(res => {
          res.data.data.sensitive_word.forEach((item, index) => {
            if (this.DetailsContent.content.indexOf(item) > 0) {
              this.keywordList.push(item)
            }
          })
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.title {
  .but {
    // width: 22rem !important;

    .back {
      width: 5.83rem;
      height: 2.5rem;
      background: #fff;
      color: #108CDD;
      border: 0;
      box-shadow: 0.17rem 0.17rem 0.33rem #000000;
      border-radius: 0.42rem;
      cursor: pointer;
    }

    .copy {
      width: 5.83rem;
      height: 2.8rem;
      border: 0;
      background: #108CDD;
      color: #fff;
      border: 0;
      border-radius: 0.42rem;
    }
  }
}

.Man_content {
  //min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 999;
  border-radius: 0.83rem;
  background: #ffffff;
  box-shadow: 0.17rem 0.17rem 0.33rem #7a7a7a;
  margin-top: 1rem;
  margin-bottom: 20px;

  .infomation {
    width: 1000px;
    height: 100px;
    margin: 0 auto;
    opacity: 1;
    border-radius: 0px 20px 0px 20px;
    background: rgba(138, 208, 255, 1);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .line {
      width: 900px;
      height: 1px;
      background-color: white;
      margin: 10px 0;
    }

    .infomationItem {
      width: 100%;
      font-size: 14px;
      text-align: left;
      padding-left: 70px;
      box-sizing: border-box;
    }
  }

  .Man_content_title_box {
    border-bottom: 0.08rem solid #aaaaaa;
    padding-bottom: 1rem;
    // margin-bottom: 1rem;
    box-sizing: border-box;

    .title {
      color: #333;
      font-size: 1.8rem;
      text-align: center;

    }


  }

  .Man_content_title {
    background: #E1F1FC;
    padding: 15px;
    box-sizing: border-box;
    color: #108CDD;
    font-size: 14px;

    span {
      cursor: pointer;
      color: #333;
      font-size: 14px;
      text-decoration: underline;
      padding-left: 5px;
    }

    i {
      font-style: normal;
      color: rgba(255, 0, 0, 1);
      font-size: 14px;

      &:first-child {
        margin-left: 10px;
      }
    }
  }

  .content_title {
    font-size: 16px;
    color: #333;
    margin: 10px 0 0 0;

  }

  .content {
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 40px;
    margin: 10px auto;
    width: 1000px;
    height: 200px;
    overflow: auto;
    //background-color: red;

    ::v-deep p {
      // font-size: 1.22rem !important;
      color: #333;
    }
  }
}

.el-divider__text {
  font-weight: 700;
}

.Man_content_item {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-right: 30px;

  img {
    width: 150px;
    height: 115px;
  }
}

.relevantQualifications_box {
  width: 100%;
  height: 200px;
  border-radius: 0.83rem;
  background: #ffffff;
  box-shadow: 0.17rem 0.17rem 0.33rem #7a7a7a;
  display: flex;
  align-items: center;
  flex-direction: column;

  .relevantQualifications_content {
    width: 100%;
    display: flex;
    align-items: center;
    //justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;

    .Man_content_item_title {
      font-weight: 700;
    }

  }
}

.line {
  width: 1px;
  height: 100px;
  background-color: #DCDFE6;
  margin-right: 30px;
}

.fillFormTime {
  color: #EF2626;
  font-size: 1.33rem;
  font-weight: bold;
  text-align: left;
}

.hint {
  color: #EF2626;
  font-size: 1.2rem;
  text-align: center;
}

.remark_box {
  background: #E1F1FC;
  padding: 1rem 0;
  max-height: 10rem;
  overflow-y: auto;
  font-size: 1.22rem;
  box-sizing: border-box;
}

.out_text {
  font-size: 14px;
  margin-bottom: 10px;
  align-items: center;

  span {
    color: #333;
  }

  a {
    display: block;
    width: 101px;
    height: 32px;
    line-height: 32px;
    border-radius: 10px;
    background: #0FA30F;
    color: #fff;
    text-decoration: none;
    text-align: center;
    margin-left: 10px;
  }
}
</style>